export default {
    header: {
        display: "flex",
        alignItems: "center",
        gap: 1.25,
        mb: 0.5
    },
    title: {
        color: "primary.700"
    },
    activeBadge: {
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        height: 22,
        px: 1,
        borderRadius: "8px",
        backgroundColor: "success.50",
        color: "success.900",
        fontWeight: 500,
        fontSize: "12px"
    },
    activeDot: {
        width: 6,
        height: 6,
        borderRadius: "50%",
        backgroundColor: "success.500"
    },
    description: {
        display: "block",
        color: "greyscale.700",
        mb: 1.5
    },
    tokenRow: {
        display: "flex",
        alignItems: "center",
        gap: 1,
        minHeight: 48,
        py: 0.75,
        pl: 1.75,
        pr: 0.75,
        borderRadius: "8px",
        border: "1px solid",
        borderColor: "greyscale.200",
        backgroundColor: "greyscale.50"
    },
    tokenValue: {
        flexGrow: 1,
        minWidth: 0,
        fontFamily: "monospace",
        color: "greyscale.900",
        wordBreak: "break-all"
    },
    placeholder: {
        flexGrow: 1,
        fontStyle: "italic",
        color: "greyscale.400"
    },
    tokenIconButton: {
        color: "greyscale.700"
    },
    copyIconButtonCopied: {
        color: "success.500"
    },
    metaRow: {
        display: "block",
        mt: 1,
        color: "greyscale.600"
    }
};
